const companyData = {
  name: "Nato Cctv Solutions",
  logo: "https://ik.imagekit.io/pkru1f3ec/nato-cctv-logo.png",
  phone: "0741695742",
  email: "natocctvsolutions@gmail.com",
  phonespace: "07 41 695 742",
  whatsapp: "741695742",
  facebook: "https://www.facebook.com/profile.php?id=100069924721948",
  x: "natocctvsolutions",
  instagram:
    "https://www.instagram.com/natocctv_solutions?igsh=YzljYTk1ODg3Zg==",
  tiktok: "https://vm.tiktok.com/ZMS5Fu7vs/",
  address: "Nakuru Wilmur house room 11, Kenyatta avenue,Next To Family Bank",
  mapcordinates: [-0.28402886822679296, 36.07295731067023],
};
export default companyData;
